import listActions from 'src/modules/eventSchedule/list/eventScheduleListActions';
import EventScheduleService from 'src/modules/eventSchedule/eventScheduleService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'EVENTSCHEDULE_DESTROY';

const eventScheduleDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: eventScheduleDestroyActions.DESTROY_STARTED,
      });

      await EventScheduleService.destroyAll([id]);

      dispatch({
        type: eventScheduleDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.eventSchedule.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/event-schedule');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventScheduleDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: eventScheduleDestroyActions.DESTROY_ALL_STARTED,
      });

      await EventScheduleService.destroyAll(ids);

      dispatch({
        type: eventScheduleDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.eventSchedule.destroyAll.success'),
      );

      getHistory().push('/event-schedule');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventScheduleDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default eventScheduleDestroyActions;
